/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'loading': {
    width: 64,
    height: 64,
    viewBox: '0 0 64 64',
    data: '<g _fill="none" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" _stroke="#272c33"><circle pid="0" cx="32" cy="32" r="6"/><circle pid="1" cx="8" cy="32" r="6"/><circle pid="2" cx="56" cy="32" r="6"/></g>'
  }
})
